import { Box, IconButton, Toolbar, useMediaQuery } from '@mui/material';
import Left from './Left';
import {
  ArticleTwoTone,
  CampaignTwoTone,
  CardGiftcardTwoTone,
  CelebrationTwoTone,
  ChevronLeftRounded,
  ChevronRightRounded,
  EmojiEventsTwoTone,
  EventTwoTone,
  FastfoodTwoTone,
  PermContactCalendarTwoTone,
  WidgetsOutlined,
  Menu,
} from '@mui/icons-material';
import { selectDrawerOpen, setDrawer } from '../../features/Search/searchSlice';
import { useDispatch, useSelector } from 'react-redux';
import { variants } from '../../variants/variants';
import { selectCurrentUser, setLayout } from '../../features/Auth/authSlice';
import Right from './Right';
import { useLocation, useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';
import { Typography } from '@mui/material';
import { cloneElement, useEffect, useState } from 'react';
import { useTheme } from '@emotion/react';

const DashboardLayout = function () {
  const open = useSelector(selectDrawerOpen);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [state, setState] = useState();
  const toggleDrawer = open => event => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState(open);
  };

  const handleToggleDrawer = () => {
    dispatch(setDrawer({ value: !open }));
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('lg'));
  const user = useSelector(selectCurrentUser);
  const { pathname } = useLocation();
  const page = pathname.split('/')[2];
  if (page == 'linkway') return null;

  if(isMobile){
    dispatch(setLayout('home'));
    navigate('/home');
  }

  const navigations = [
    { title: 'User', path: 'user', icon: <PermContactCalendarTwoTone /> },
    { title: 'Delights', path: 'delights', icon: <FastfoodTwoTone /> },
    { title: 'GIFT', path: 'gift', icon: <CardGiftcardTwoTone /> },
    { title: 'RnR', path: 'rnr', icon: <EmojiEventsTwoTone /> },
    { title: 'Shabash', path: 'shabash', icon: <CelebrationTwoTone /> },
    { title: 'Pings', path: 'announcement', icon: <CampaignTwoTone /> },
    { title: 'GNN', path: 'gnn', icon: <ArticleTwoTone /> },
    { title: 'Leave', path: 'leave', icon: <EventTwoTone /> },
    { title: 'Gateway Box', path: 'gatewaybox', icon: <WidgetsOutlined /> },
  ];

  return (
    <Box sx={{ display: 'flex' }}>
      <Left state={state} toggleDrawer={toggleDrawer} />
      <Box sx={{ flexGrow: 1, position: 'relative' }}>
        <Toolbar sx={{ borderBottom: 1, borderColor: 'divider', fontWeight: 'bold', fontSize: '18px' }}>
          <IconButton
            onClick={toggleDrawer(true)}
            sx={{
              display: 'none',
              [theme.breakpoints.down('lg')]: {
                display: 'flex',
                mr: 1,
              },
            }}
          >
            <Menu />
          </IconButton>
          <Grid item display={'flex'} justifyContent={'start'} alignItems={'center'}>
            {cloneElement(navigations?.find(icon => icon.path === page)?.icon || <></>, {
              sx: { color: variants.primary, fontSize: '30px' },
            })}
            <Typography component={'div'} ml={1} fontWeight={'bold'}>
              {navigations?.find(title => title.path === page)?.title}
            </Typography>
          </Grid>
        </Toolbar>
        <IconButton
          sx={{
            color: variants.icon.inactive.background,
            background: '#fff',
            ':hover': { background: '#fff' },
            p: 0,
            zIndex: 1000,
            border: 1,
            position: 'absolute',
            top: 20,
            left: -12,
            [theme.breakpoints.down('lg')]: {
              display: 'none',
            },
          }}
          onClick={handleToggleDrawer}
        >
          {open ? <ChevronLeftRounded fontSize='small' /> : <ChevronRightRounded fontSize='small' />}
        </IconButton>
        <Right />
      </Box>
    </Box>
  );
};

export default DashboardLayout;
